import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;

function sessionId() {
  let id = localStorage.getItem("dg_chat_session");
  if (!id) { id = `s-${crypto.randomUUID()}`; localStorage.setItem("dg_chat_session", id); }
  return id;
}

const withId = (m) => ({ ...m, id: m.id || m.at || crypto.randomUUID() });

async function readStream(res, onDelta) {
  const reader = res.body.getReader(); const dec = new TextDecoder(); let buf = "";
  while (true) {
    const { value, done } = await reader.read(); if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n"); buf = parts.pop();
    for (const p of parts) {
      const line = p.replace(/^data: /, "");
      if (line === "[DONE]") continue;
      try { onDelta(JSON.parse(line).t); } catch (err) { console.warn("Ask Dr.Gadget: skipped malformed stream chunk", err); }
    }
  }
}

export function useChat(open) {
  const [msgs, setMsgs] = useState([]);
  const [busy, setBusy] = useState(false);
  const sid = useRef(sessionId());

  useEffect(() => {
    if (!open) return;
    api.get(`/chat/${sid.current}`).then((r) => {
      const loaded = (r.data || []).map(withId);
      if (loaded.length) setMsgs((cur) => (cur.length === 0 ? loaded : cur));
    }).catch(() => {});
  }, [open]);

  const appendToLast = (t) => setMsgs((m) => {
    if (!m.length) return m;
    const c = [...m]; const last = c[c.length - 1];
    c[c.length - 1] = { ...last, content: (last.content || "") + t }; return c;
  });

  const send = useCallback(async (message) => {
    if (!message || busy) return;
    setBusy(true);
    setMsgs((m) => [...m, withId({ role: "user", content: message }), withId({ role: "assistant", content: "" })]);
    try {
      const res = await fetch(`${BASE}/api/chat`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sid.current, message }),
      });
      await readStream(res, appendToLast);
    } catch {
      setMsgs((m) => { const c = [...m]; c[c.length - 1] = { ...c[c.length - 1], content: "Connection problem — please try again or call 310-422-0669." }; return c; });
    } finally { setBusy(false); }
  }, [busy]);

  const toTicket = useCallback(() => api.post(`/chat/${sid.current}/to-ticket`, null, { timeout: 60000 }), []);

  return { msgs, busy, send, toTicket };
}
